import { ROUTES } from '@/router/routesEnum';
import { OdataItems } from '@/shared/model/OdataItems';
import { SearchParams } from '@/shared/model/searchParams';
import { CONST } from '@/shared/utils/Constants';
import Vue from 'vue';
import { Component, Watch } from 'vue-property-decorator';
import { Contact } from '@/shared/model/contact';
import { namespace } from 'vuex-class';
import GeneralUtils, {delay} from '@/shared/utils/generalUtils';
import D4yTable from '@/components/d4y-table/d4y-table.vue';
import DateField from '@/components/_common/date-field/DateField.vue';
import {CountryUtils} from '@/shared/utils/countryUtils';
import { Country } from '@/shared/model/country.model';



const orderIdUrlParam = 'oid';
const contactEntraIdUrlParam = 'id';
// get object property and ignore case
const getObjProperty = (obj: any, prop: string) =>
  Object.entries(obj).find(([key]) => key.toLowerCase() === prop.toLowerCase())?.[1]; // would return pair ['key', 'value'] so need `1` index

const name = 'spotmarktOrderSplitFormComponent';
const contactModule = namespace('contact');
const authModule = namespace('auth');

@Component({ name: name, components: { D4yTable, DateField } })
export default class SpotmarktOrderSplitFormComponent extends Vue {

  @contactModule.Getter('getContactForLoggedInUser')
  private contactForLoggedInUser!: Contact;
  @contactModule.Action('getContactByAzureId')
  private actionGetContactByAzureId!: any;
  @contactModule.Action('getContactOrder')
  private getContactOrder!: any;
  @contactModule.Action('getSpotMarktLogsByOrder')
  private getSpotMarktLogsByOrder!: any;
  @contactModule.Action('GetContactOrderCustomers')
  private GetContactOrderCustomers!: any;
  @contactModule.Action('addOrder')
  private actionAddOrder!: any;
  @contactModule.Action('recalculateOrder')
  private recalculateOrder!: any;
  @contactModule.Action('updateOrderState')
  private updateOrderState!: any; // (AD-224) !! not working since get error from ShopWare 6 that no rights to directly change `Order -> stateId`


  get orderIdUrl() {
    return getObjProperty(this.$route.query, orderIdUrlParam);
  }
  get hasOrderIdInUrl() {
    return !!getObjProperty(this.$route.query, orderIdUrlParam);
  }
  get hasContactIdInUrl() {
    return !!getObjProperty(this.$route.query, contactEntraIdUrlParam);
  }

  isValid = false;

  dateSearch: any = '';
  contactZrs: any = {};
  orderAllData: any = {};
  orderItems: any[] = [];
  orderTransactions: any[] = [];
  numa = 0;
  formData: any = {};
  offerProductObj: any = {};
  orderCustomers: any[] = [];

  get totalQuantityObj() {
    return this.orderItems?.reduce((sum, item) => sum + item.quantity, 0);
  }

  get isSingleOrNoZr() {
    return (this.contactZrs?.zrs?.length <= 1);
  }

  @Watch("formData", { deep: true })
  onFormdataChange() {
    // console.log('this.formData :>> ', this.formData);
    // console.log('zzzzz formData watcher:>> ');
    this.totalNumberInputsValue();
  }

  lastFailingInputKey: any = null;
  getSumByProduct(productIndex: number) {
    const prefix = productIndex.toString();
    return Object.entries(this.formData)
      .filter(([key]) => key.startsWith(prefix))
      .reduce((sum, [, value]: any) => sum + Number(value.number), 0);
  }

  get validationResults() {
    return this.orderItems?.map((item, i) => {
      const sum = this.getSumByProduct(i);

      return {
        productIndex: i,
        allowedQuantity: item.quantity,
        sum,
        valid: sum <= item.quantity
      };
    });
  }

  preventMinus(event: any) {
    if (event.key === '-') {
      event.preventDefault();
    }
  }

  validateProduct(productIndex: number, changedKey: number) {
    let productOffer = this.offerProductObj[productIndex];

    const sum = Object.entries(this.formData)
      .filter(([key]) => key.startsWith(productIndex.toString()))
      .reduce((total, [, val]: any) => total + Number(val.number), 0);

    const valueAfterDifference = productOffer.quantityInit - sum;
    productOffer.quantity = valueAfterDifference >= 0 ? valueAfterDifference : 0;
    // console.log('offer.quantity :>> ', productOffer.quantity);


    const allowedQuantity = this.orderItems[productIndex].quantity;

    // console.log('this.lastFailingInputKey :>> ', this.lastFailingInputKey);
    if (sum > allowedQuantity) {
      this.lastFailingInputKey = changedKey;  // Remember the input that caused failure
    } else if (this.lastFailingInputKey && this.lastFailingInputKey.toString().startsWith(productIndex.toString())) {
      // Clear the failing input key if no longer failing for this product
      this.lastFailingInputKey = null;
    }
  }

  get areAddressesValid() {
    const isValid = Object.values(this.addressErrors).every((arr: string[]) => arr.length === 0);
    return isValid;
  }


  // Overall form validity
  get isFormValid() {
    return this.validationResults.every(r => r.valid) && this.isAllProductsSplit && this.areAddressesValid;
  }

  totalNumberInputsNum = 0;
  totalNumberInputsValue() {
    // console.log('xx Object.entries(this.formData) :>> ', Object.entries(this.formData));
    // console.log('this.formData :>> ', this.formData);
    let result = Object.values(this.formData)?.reduce((sum: number, item: any) => {
      // console.log('xx sum :>> ', sum);
      // console.log('xx item :>> ', item);
      // console.log('xx item.number :>> ', item.number);
      // console.log('xx +(item as any).number :>> ', +(item as any).number);
      return sum + (+(item as any).number || 0)
    }, 0);

    this.totalNumberInputsNum = result;
  }

  get contactZrNummersOnlyNumbersArr() {
    let contactZrNumsOnly = this.contactZrs.zrs?.map((x: any) => x.zrNummer);

    if (!!contactZrNumsOnly) {
      contactZrNumsOnly = contactZrNumsOnly?.length > 0 ? contactZrNumsOnly : null;
    }
    return contactZrNumsOnly || [];
  }


  get contactZrNummers() {
    let contactZrWithName = this.contactZrs.zrs?.map((x: any) => {
      return `${x.zrNummer} (${x.name})`;
    })

    if (!!contactZrWithName) {
      contactZrWithName = contactZrWithName.join(', ');
    }
    return contactZrWithName || '...';
  }
  get contactZrNummersArr() {
    return this.contactZrNummers?.split(',');
  }
  get orderZrNumber() {
    let result = this.orderAllData?.orderCustomer?.customerNumber;
    if (result) {
      const value = this.contactZrs.zrs?.find((x: any) => x.zrNummer == result);
      if (value) {
        result = `${value.zrNummer} (${value.name})`
      }
    }

    return result || '...';
  }

  get headers() {
    const headers: {
      text: string | any;
      value: string;
      sortable?: boolean;
      width?: string;
    }[] = [
        { text: this.$t('name'), value: 'label' },
        { text: this.$t('quantity'), value: 'quantity' },
        { text: this.$t('type'), value: '' },
      ];
    return headers;
  }
  createdOrderLogs: any[] = [];

  created() {
    console.log('zzz getObjProperty(this.$route.query, orderIdUrlParam) :>> ', getObjProperty(this.$route.query, orderIdUrlParam));
    console.log('zzz getObjProperty(this.$route.query, contactEntraIdUrlParam) :>> ', getObjProperty(this.$route.query, contactEntraIdUrlParam));
    if (this.hasContactIdInUrl) {
      const contactAzureId = getObjProperty(this.$route.query, contactEntraIdUrlParam);
      // const orderId = getObjProperty(this.$route.query, orderIdUrlParam);
      this.getSpotMarktLogsByOrder(this.orderIdUrl).then((result: any) => {
        console.log('zzz getSpotMarktLogsByOrder result :>> ', result);
        this.createdOrderLogs = result;
      });
      this.actionGetContactByAzureId(contactAzureId).then((result: any) => {
        this.contactZrs = result;
        // this.contactZrs.zrs = [result.zrs[0]]; // (AD-228) test to hide table for `SingleZr`
        this.getContactOrder(this.orderIdUrl).then((resultOrd: any) => {
          console.log('zzz getContactOrder:>> ', resultOrd);
          this.orderAllData = resultOrd;
          this.orderItems = resultOrd.lineItems;
          this.orderTransactions = resultOrd.transactions;


          this.populateFormData();
          console.log('zz this.offerArr :>> ', this.offerProductObj);
        }).catch((err: any) => {

        });


        let orderCustomerPayload = this.contactZrNummersOnlyNumbersArr;
        // xx.push('bugs') // tested locally dynamic `zrNummer`
        this.GetContactOrderCustomers(orderCustomerPayload).then((result: any) => {
          this.orderCustomers = result;
        }).catch((err: any) => {

        });;
      }).catch((err: any) => {

      });;
    }
  }

  populateFormData() {

    this.orderItems.forEach((lineItem: any, j: number) => {

      let offerQuantity = lineItem.quantity;

      this.contactZrNummersArr.forEach((zrNum: string, i: number) => {
        let formDataItem =
        {
          itemId: lineItem.id,
          zrNum: zrNum, number: 0,
          productId: this.orderItems[j].identifier,
          addressText: '', processed: false
        }
        const logEntry = this.createdOrderLogs.find((x: any) => x.productId == formDataItem.productId && x.zrNummer == zrNum);
        if (!!logEntry) {
          formDataItem.number = logEntry.productQuantity;
          formDataItem.processed = true;
          if (logEntry.customAddress && logEntry.customAddress.length > 10) {
            formDataItem.addressText = logEntry.customAddress;
          }

          let difference: number = +offerQuantity - +logEntry.productQuantity;
          offerQuantity = difference >= 0 ? difference : 0;
        }

        this.offerProductObj[j] = { id: j, quantity: offerQuantity, quantityInit: offerQuantity }; // (AD-228-01) `quantity` to show in HTML, `quantityInit` for right calculations when reduce number (if have only `quantity` it will not increase on number reduce)

        this.$set(this.formData, j + '' + i, formDataItem);
      });

    });
  }

  get processedRecordsCount() {
    const processed = Object.values(this.formData).filter((x:any)=> x.processed);
    const sumNumber = processed.reduce((acc:number, item: any) => acc + (+item.number), 0);
    // console.log('sumNumber :>> ', sumNumber);
    return sumNumber;
  }

  get isAllRecordsProcessed(){
    return this.processedRecordsCount == this.totalQuantityObj;
  }

  get isAllProductsSplit() {
    const allSplitsSum = Object.entries(this.formData)
      .reduce((total, [, val]: any) => total + Number(val.number), 0);
    console.log('allSplitsSum :>> ', allSplitsSum);
    const productsQuantity = this.totalQuantityObj;
    // console.log('this.totalQuantityObj :>> ', this.totalQuantityObj);

    // when user `allSplitsSum` > productsQuantity we consider that this rule is Valid (all was splitted)
    const conditions = (productsQuantity == allSplitsSum) || ((allSplitsSum - productsQuantity) >= 1);
    return conditions;
  }

  onClickClose() { 
    window.close();
  }

  showFormValidationMessage = false;
  isOrdersProcessing = false;
  isSaveBtnWasClicked = false;
  async onClickSave() {
    this.isSaveBtnWasClicked = true;
    console.log('this.createdOrderLogs :>> ', this.createdOrderLogs);
    console.log('this orderAllData:>> ', this.orderAllData);

    // return;
    if (!this.isFormValid) {
      this.showFormValidationMessage = true;
      return;
    } else {
      this.showFormValidationMessage = false;
    }

    const arr = Object.entries(this.formData).map(([key, value]) => ({ key, ...(value as any) }));
    console.log('zzz arr :>> ', arr);
    const rowsWithValues = arr.filter((x: any) => x.number > 0 && !x.processed);
    console.log('zzzrowsWithValues:>> ', rowsWithValues);

    // Custom sort function that compares based on numeric value of 'key'
    rowsWithValues.sort((a, b) => {
      return parseInt(a.key, 10) - parseInt(b.key, 10);
    });

    // rowsWithValues.forEach((element, index) => {
    //   this.buildOrderPostJson(element);
    // });
    this.isOrdersProcessing = true;
    for (const element of rowsWithValues) {
      this.buildOrderPostJson(element); // delay of 1.5 seconds between iterations
      //
      if (element !== rowsWithValues[rowsWithValues.length - 1]) { await delay(5000); }
    }
    this.isOrdersProcessing = false;


  }

  isInitialRequest = true;
  async mounted() {
    this.isInitialRequest = false;
  }


  get image() {
    return {};
  }

  get isRealXl() {
    return this.$vuetify.breakpoint.width < 1920;
  }


  getFormatingText(conditionChangeValue: any) {
    let conditionText: string = '';
    if (conditionChangeValue != null) {
      conditionText = conditionChangeValue.replaceAll('\n', '<br>');
    }
    return conditionText;
  }

  addDaysToNowAndIso(days: number = 0, resetTime = true) {
    const now = new Date();

    if (resetTime) {
      now.setUTCHours(0, 0, 0, 0);
    }
    // Add 7 days
    now.setUTCDate(now.getUTCDate() + days);

    const isoString = now.toISOString().replace('Z', '+00:00');

    return isoString;
  }

  removeKeysByName(obj: any, keyName: string) {
    if (typeof obj !== 'object' || obj === null) {
      return;
    }

    for (const key in obj) {
      if (obj.hasOwnProperty(key)) {
        if (key === keyName) {
          delete obj[key];
        } else {
          // Recursively handle nested objects
          this.removeKeysByName(obj[key], keyName);
        }
      }
    }
  }

  compareOrderLogs(a: any, b: any): number {
    const numA = parseInt(a.orderNumber.split('-')[1], 10); // Extract number after the '-'
    const numB = parseInt(b.orderNumber.split('-')[1], 10); // Same for b
    return numB - numA; // Sort in descending order based on the number
  }


  calculateOrderNumberPostfix() {
    if (this.createdOrderLogs.length == 0) {
      return '01';
    }
    else {
      const orderLogs = this.createdOrderLogs.sort(this.compareOrderLogs);
      console.log('zzz calculateOrderNumberPostfix orderLogs :>> ', orderLogs);
      const lastOrderNum = orderLogs[0].orderNumber;
      const numPostfix = parseInt(lastOrderNum.split('-')[1], 10);
      const nextNum = numPostfix + 1;
      const result = nextNum < 10 ? `0${nextNum}` : `${nextNum}`;
      console.log('zzz calculateOrderNumberPostfix :result >> ', result);
      return result;
    }
  }

  // (AD-228-05) 2 used countries based on current 16 orders in the System
  // https://spotmarkt.meinvme.de/api/country
  countries: Country[] = CountryUtils.countries;



  addressErrors: Record<string, string[]> = {};
  addressRule(value: string, key: string) {
    if (!value) return true;
    const parts = value.split(',').map(s => s.trim());

    // Must have exactly 4 parts
    if (parts.length !== 4) {
      return this.$t('address_invalid_format');
    }

    // TODO: improve this part
    // Check length of each part
    const allValid = parts.every((part, index) => {
      if (index === 3) {
        // 4th part (land) can be like `DE`
        return part.length >= 2;
      } else {
        // name, street (with number), city zip
        return part.length >= 4;
      }
    });

    if (!allValid) {
      return this.$t('address_invalid_format');
      // return this.$t('address_part_too_short');
    }

    return true;
  }

  validateAddress(key: string) {
    const value = this.formData[key].addressText;
    const result = this.addressRule(value, key);
    // this.$set(this.addressErrors, key, result === true ? '' : result);
    this.$set(this.addressErrors, key, result === true ? [] : [result])
  }

  /**
   * Extracts ZIP(postal) code and city from a string where ZIP code can be
   * at the start or end. ZIP code supports alphanumeric characters,
   * spaces, and hyphens (e.g. "12345", "SW1A 1AA").
   *
   * @param {string} cityWithZip - The combined city and ZIP(postal) code string.
   * @returns {Object} - { zip: string|null, city: string|null }
   */
  extractZipAndCity(cityWithZip: string) {
    if (!cityWithZip) return { zip: null, city: null };

    const trimmedString = cityWithZip.trim();

    // Regex explanation:
    // Matches either:
    // 1. Postal code (3-10 chars) at start, followed by one or more spaces, then city name
    // 2. City name at start, followed by one or more spaces, then postal code (3-10 chars) at end
    const postalCityPattern = /^([\w\s-]{3,10})\s+(.+)$|^(.+)\s+([\w\s-]{3,10})$/i;

    // 4 groups of Regex values `()` so will be array of 4 matches
    const matches = trimmedString.match(postalCityPattern);

    if (!matches) {
      // No postal code found; whole string considered `city`
      return { zip: null, city: trimmedString };
    }

    // If ZIP at start
    if (matches[1] && matches[2]) {
      return {
        zip: matches[1].trim(),
        city: matches[2].trim()
      };
    }

    // If ZIP at end
    if (matches[3] && matches[4]) {
      return {
        zip: matches[4].trim(),
        city: matches[3].trim()
      };
    }

    return { zip: null, city: trimmedString };
  }




  buildOrderPostJson(element: any) {

    console.log('zzz order all :>> ', this.orderAllData);
    const item = this.formData[element.key];
    const order = this.orderAllData;
    const orderCustomerNumber = this.orderAllData.orderCustomer?.customerNumber;
    console.log('orderCustomerNumber :>> ', orderCustomerNumber);
    const customerNum = item.zrNum.trim().split(" ")[0]; // `zrNum` has stable format like `112212 (Kauer Möbuhuus Aegerten)`
    const customerObj: any = this.orderCustomers.find((x: any) => x.customerNumber == customerNum);
    console.log('zzz custObj :>> ', customerObj);
    const billingAddress = customerObj?.defaultBillingAddress;

    // console.log('orderCustomerNumber == customerNum :>> ', orderCustomerNumber == customerNum);
    // console.log('orderCustomerNumber, == customerNum :>> ', orderCustomerNumber, '==', customerNum);

    //#region (AD-228) set shipping address
    //!! The `shippingAddress` inside `deliveries` is read-only during order creation — it’s populated by Shopware from the `shippingAddressId` (or the customer’s default address).
    //!! to use a different shipping address and create new address in 1 request (with POST(create) order) need to populate `"addresses"` array of objects (same syntax as for `deliveries`)

    let useNewAddress = false;
    let shippingAddress: any = null;
    let newShippingAddress: any = null;
    let shippingAddressIdForDelivery : string = '';
    /// 1. If `Order -> CustomerNumber` == `ZrNummer` and NO value in Address column, then take address from Deliveries
    if (item.addressText.length > 0) {
      // TODO parse `addressText` for ShippingAddress
      // const addressItems = item.addressText.split(',');
      const [companyName, street, zip_city, country] =
        item.addressText.split(',').map((x: any) => x.trim());

      console.log(companyName);  // "EtaCom Corp"
      console.log(street); // "1234"
      console.log(zip_city);   // "56789"
      console.log(country);      // "DE"

      const { zip, city } = this.extractZipAndCity(zip_city);
      const defaultCountry: Country = CountryUtils.findCountry("DE")!;
      const countryObj: Country = CountryUtils.findCountry(country) ?? defaultCountry;
      // console.log('countryObj :>> ', countryObj);

      shippingAddress = {};
      shippingAddress.countryId = countryObj?.id;
      shippingAddress.salutationId = customerObj?.salutationId;
      shippingAddress.firstName = "__";
      shippingAddress.lastName = "__";
      shippingAddress.zipcode = zip;
      shippingAddress.city = city;
      shippingAddress.company = companyName;
      shippingAddress.street = street;

      newShippingAddress = shippingAddress;
      useNewAddress = true;
      // console.log('zzz shippingAddress :>> ', shippingAddress);
    } else  if (orderCustomerNumber == customerNum) {
      // !! (AD-228) was trying to reuse existing `orderAddress` for new `Order` but ShopWare has concept that EVERY `Order` has own `orderAddress` and it cannot be shared among multiple `Order` entities
      const deliveries = order.deliveries;
      if (deliveries.length == 1) {
        // shippingAddress = deliveries[0].shippingOrderAddress;
        shippingAddressIdForDelivery = deliveries[0].shippingOrderAddressId;

        shippingAddress = {};
        shippingAddress.countryId = deliveries[0].shippingOrderAddress.countryId;
        shippingAddress.salutationId = deliveries[0].shippingOrderAddress.salutationId;
        shippingAddress.firstName = deliveries[0].shippingOrderAddress.firstName;
        shippingAddress.lastName = deliveries[0].shippingOrderAddress.lastName;
        shippingAddress.zipcode = deliveries[0].shippingOrderAddress.zipcode;
        shippingAddress.city = deliveries[0].shippingOrderAddress.city;
        shippingAddress.company = deliveries[0].shippingOrderAddress.company;
        shippingAddress.street = deliveries[0].shippingOrderAddress.street;

        newShippingAddress = shippingAddress;
        useNewAddress = true;
      }
      console.log('zzz deliveries :>> ', deliveries);
    } else {
      shippingAddressIdForDelivery = customerObj.defaultShippingAddressId; //defaultShippingAddress; // discussed with Chaslau that if `Order -> CustomerNumber` != `ZrNummer` use old logic (address from `customerObj`)
      // !! OUTDATED comment  // const shippingAddress = customerObj.defaultShippingAddress; // WRONG shipping address, should take it from `order -> deliveries -> shippingOrderAddress`
    }

    //#endregion


    const nowIso = new Date().toISOString().replace('Z', '+00:00');
    // console.log('zzz nowIso :>> ', nowIso);
    // console.log('zzz nowIso :>> ', this.addDaysToNowAndIso());
    // console.log('zzz nowIso 7 :>> ', this.addDaysToNowAndIso(7));
    // console.log('zzz nowIso 14:>> ', this.addDaysToNowAndIso(14));

    const product = this.orderItems.find((x: any) => x.id == item.itemId);
    console.log('zzz product>> ', product);
    let productPrice = product.price;
    productPrice.quantity = +item.number;
    let productPriceDef = product.priceDefinition;
    productPriceDef.quantity = +item.number;
    console.log('zzz productPriceDef.quantity :>> ', productPriceDef.quantity);

    const transaction = this.orderTransactions[0];
    let transactionAmount = transaction.amount;
    transactionAmount.quantity = +item.number

    const min = 1;
    const max = 100;
    const randomNumber = Math.floor(Math.random() * (max - min + 1)) + min;

    let number = this.calculateOrderNumberPostfix();


    // console.log('zzz item.addressText :>> ', item.addressText);
    // return;
    const orderPayload: any = {
      'orderNumber': `${order.orderNumber}-${number}`, //`from Admin-Panel ${randomNumber} + ${item.addressText}`,
      'source': 'zrSplitterForm',
      'customerId': customerObj.id,
      'billingAddress': {
        'customerId': billingAddress.customerId,
        'countryId': billingAddress.countryId,
        'salutationId': billingAddress.salutationId,
        'firstName': billingAddress.firstName,
        'lastName': billingAddress.lastName,
        'zipcode': billingAddress.zipcode,
        'city': billingAddress.city,
        'company': billingAddress.company,
        'street': billingAddress.street
      },
      'currencyId': order.currencyId,
      'salesChannelId': order.salesChannelId,
      'languageId': order.languageId,
      'orderDateTime': this.addDaysToNowAndIso(0, false),
      'currencyFactor': order.currencyFactor,
      'stateId': order.stateId,
      'ruleIds': order.ruleIds,
      'customFields': {
        'custom_ordertype_value': true
      },
      'itemRounding': order.itemRounding,
      'totalRounding': order.totalRounding,
      // TODO: investigate what values should be here
      'price': {
        'calculatedTaxes': {},
        'netPrice': 0,
        'positionPrice': 0,
        'rawTotal': 0,
        'taxRules': {},
        'taxStatus': 'net',
        'totalPrice': 0
      },
      'shippingCosts': {
        'calculatedTaxes': {},
        'listPrice': null,
        'quantity': 1,
        'referencePrice': null,
        'regulationPrice': null,
        'taxRules': {},
        'totalPrice': 0,
        'unitPrice': 0
      },

      'orderCustomer': {
        'customerId': customerObj.id,
        'email': customerObj.email,
        'salutationId': customerObj.salutationId,
        'firstName': customerObj.firstName,
        'lastName': customerObj.lastName,
        'company': customerObj.company,
        'customerNumber': customerObj.customerNumber,
        'customFields': customerObj.customFields,
        'remoteAddress': customerObj.remoteAddress
      },


      //shippingDateEarliest for `Standard` delivery `orderDate` + 7days (`..latest` + 14 days )
      'deliveries': [
        {
          'shippingMethodId': '0194f5c322ff7075beb7de890891bc52',
          'stateId': '0194f5c3277370888f16285264b1a8db',
          'shippingDateEarliest': this.addDaysToNowAndIso(7),
          'shippingDateLatest': this.addDaysToNowAndIso(14),
          // (AD-228) by try and errors find out that tou use different address than `defaultShippingAddress` from Customer
          'shippingAddressId': shippingAddressIdForDelivery,
          // 'shippingAddress': {
          //   //'id': shippingAddress.id, // not sure that need it
          //   'customerId': customerObj.id,
          //   'countryId': shippingAddress.countryId,
          //   'salutationId': shippingAddress.salutationId,
          //   'firstName': shippingAddress.firstName,
          //   'lastName': shippingAddress.lastName,
          //   'zipcode': shippingAddress.zipcode,
          //   'city': shippingAddress.city,
          //   'company': shippingAddress.company,
          //   'street': shippingAddress.street
          // },
          'shippingCosts': {
            'calculatedTaxes': {},
            'listPrice': null,
            'quantity': 1,
            'referencePrice': null,
            'regulationPrice': null,
            'taxRules': {},
            'totalPrice': 0,
            'unitPrice': 0
          }
        }
      ],
      'lineItems': [
        {
          'coverId': product.coverId,
          'good': product.good,
          // 'id': product.id,
          'identifier': product.identifier,
          'label': product.label,
          'payload': product.payload,
          'position': product.position,
          'price': productPrice,
          'priceDefinition': productPriceDef,
          'productId': product.productId,

          'quantity': +item.number,
          'referencedId': product.productId,
          'removable': product.removable,
          'stackable': product.stackable,
          'totalPrice': product.totalPrice,
          'type': product.type,
          'unitPrice': product.unitPrice
        }
      ],

      'transactions': [
        {
          'paymentMethodId': transaction.paymentMethodId,
          'amount': transactionAmount,
          'validationData': transaction.validationData,
          'stateId': transaction.stateId
        }
      ]

    };

    this.removeKeysByName(orderPayload, 'apiAlias')

    if (useNewAddress) {
      const newAddressId = GeneralUtils.generateShopwareUUID();
      orderPayload.addresses = [
        {
          id: newAddressId,
          customerId: orderPayload.customerId,
          ...newShippingAddress
        }
      ];
      orderPayload.deliveries[0].shippingAddressId = newAddressId;
    }

     console.log('zzz orderPayload :>> ', orderPayload);

    let data: any = //JSON.stringify(payload);
    {
      orderBody: JSON.stringify(orderPayload),
      sourceOrderId: this.orderIdUrl,
      orderNumber: orderPayload.orderNumber,
      zrNummer: item.zrNum,
      productId: product.identifier,
      productLabel: product.label,
      productQuantity: +item.number
    };

    if (useNewAddress) {
      data.customAddress = item.addressText;
    }


    console.log('zzz data :>> ', data);
    //  console.log('zzz JSON.stringify(payload) :>> ', JSON.stringify(payload));
    this.actionAddOrder(data).then((result: any) => {
      console.log('zzz  actionAddOrder:>> ', result); // returned `orderNumber`
      this.createdOrderLogs.push({
        orderNumber: orderPayload.orderNumber,
        zrNummer: item.zrNum,
        productId: product.identifier,
        productLabel: product.label,
        productQuantity: +item.number
      });

      this.recalculateOrder({
        orderNumber: result
      }).then((result: any) => {
        // !! (AD-224) changing `stateId` return error `NOT ENOUGH RIGHTS` so commented for now . DELETE OR REDO logic for change `stateId`
        // if (order.stateId != "0194f5c326dd71e2b5a57c0c110b0aca") {
        //   this.updateOrderState({
        //     orderId: this.orderIdUrl
        //   }).then((result:any) => {
        //     console.log('zzz updateOrderState  res:>> ', result);
        //     order.stateId = "0194f5c326dd71e2b5a57c0c110b0aca";
        //     this.orderAllData.stateId = "0194f5c326dd71e2b5a57c0c110b0aca";
        //   }).catch((err:any) => {
        //       console.error('zzz  ERR updateOrderState:>> ', err);
        //   });
        // }
        item.processed = true;
        console.log('zzzz recalculateOrder:>> ', result);
      }).catch((err: any) => {
        console.error('zzz  ERR recalculateOrder:>> ', err);
      });
    }).catch((err: any) => {
      console.error('zzz  ERR actionAddOrder:>> ', err);
      setTimeout(() => {
        this.isOrdersProcessing = false;
      }, 2500);
    });
  }

  getZrNummer(item: any) {
    return item.cnd_zrnummer;
  }

  enterSelect(values: any) {
  }
  completedFiles() { }
}
